module.exports = __webpack_public_path__ + "static/media/logo.6111155e.png";